import {
  Text,
  Box,
  UnorderedList,
  ListItem,
  Flex,
  Avatar,
} from "@chakra-ui/react";
import UserAvatar from "../UserAvatar";
import { AVATAR_URL } from "utils/constants";

const BorrowerContactSearch = ({
  searchQuery,
  filterBorrowerContacts,
  handleEntityClick,
}: {
  searchQuery: string;
  filterBorrowerContacts: any;
  handleEntityClick: any;
}) => {
  return (
    <Box
      mt="20px"
      borderBottom="1px solid #E2E2E2"
      borderBottomColor="gray.50"
      borderBottomWidth="1px"
    >
      <Text fontWeight={"600"} fontSize={"12px"} mb={"10px"}>
        Borrowers
      </Text>
      <UnorderedList listStyleType="none">
        {searchQuery ? (
          filterBorrowerContacts().length > 0 ? (
            filterBorrowerContacts().map((member: any) => (
              <ListItem
                key={member.id}
                ml={"-15px"}
                w={"100%"}
                _hover={{ cursor: "pointer", background: "#F9F8F8" }}
                onClick={() => handleEntityClick("borrowers", member.id)}
              >
                <Flex justifyContent="space-between" alignItems="center">
                  <Flex alignItems="center" p={"8px"}>
                    <UserAvatar size="48px" user={member} mr="12px" />
                    {/* <Avatar
                                            width="40px"
                                            height="40px"
                                            key={member.id}
                                            src={`${AVATAR_URL}${member.id}`}
                                            name={`${member.first_name} ${member.last_name}`}
                                        /> */}
                    <Flex flexDir="column">
                      <Text
                        color="black"
                        fontSize="14px"
                        fontWeight="500"
                        mb="5px"
                      >
                        {member.first_name} {member.last_name}
                      </Text>
                      <Text
                        color="gray.200"
                        fontSize="12px"
                        lineHeight="12px"
                        mt="0px"
                      >
                        {member.role.name}
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>
              </ListItem>
            ))
          ) : (
            <Box
              style={{
                height: "92px",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <Text ml={"-15px"}>No borrower matched.</Text>
            </Box>
          )
        ) : (
          <Box
            style={{
              height: "92px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text ml={"-55px"}>Enter a search query to find borrower.</Text>
          </Box>
        )}
      </UnorderedList>
    </Box>
  );
};

export default BorrowerContactSearch;
